<template>
  <div>{{widget}}</div>
</template>

<script>
  export default {
    name: 'Start',
    props: ['widget'],
    data () {
      return {}
    },
    created () {
      const map = this.widget.object_maps.data[0]
      if (map) {
        this.$router.push(`${this.widget.slug}/map/${map.id}`)
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Start.vue